import React from "react";
import ReactDOM from "react-dom";

import App from "entry";

import "core-js/es/object";
import "core-js/es/array";

import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));
